import { combineReducers } from 'redux'
import * as actions from '../actions'
import booleanReducer from '../utils/booleanReducer'

export const initialState = {
  isFetching: false,
  item: null,
  isPuttingTags: false,
  putTagError: null,
  isPuttingMarket: false,
  putMarketError: null,
  isPostingOpportunityTagsReviewed: false,
}

const isFetching = booleanReducer({
  defaultState: initialState.isFetching,
  trueTypes: [actions.GET_OPPORTUNITY_REQUEST],
  falseTypes: [
    actions.GET_OPPORTUNITY_SUCCESS,
    actions.GET_OPPORTUNITY_FAILURE,
  ],
})

const isPuttingTags = booleanReducer({
  defaultState: initialState.isPuttingTags,
  trueTypes: [actions.PUT_CATEGORY_TAGS_REQUEST],
  falseTypes: [
    actions.PUT_CATEGORY_TAGS_SUCCESS,
    actions.PUT_CATEGORY_TAGS_FAILURE,
  ],
})

const isPuttingMarket = booleanReducer({
  defaultState: initialState.isPuttingMarket,
  trueTypes: [actions.PUT_MARKET_REQUEST],
  falseTypes: [actions.PUT_MARKET_SUCCESS, actions.PUT_MARKET_FAILURE],
})

const isPostingOpportunityTagsReviewed = booleanReducer({
  defaultState: initialState.isPostingOpportunityTagsReviewed,
  trueTypes: [actions.POST_TAGS_REVIEWED_BY_REQUEST],
  falseTypes: [
    actions.POST_TAGS_REVIEWED_BY_SUCCESS,
    actions.POST_TAGS_REVIEWED_BY_FAILURE,
  ],
})

const item = (state = initialState.item, { type, payload, meta }) => {
  switch (type) {
    case actions.GET_OPPORTUNITY_SUCCESS:
      return payload
    case actions.POST_TAGS_REVIEWED_BY_SUCCESS:
      return {
        ...state,
        tagsReviewedByEmail: meta.userEmail,
        tagsReviewedOnUtc: meta.reviewedDate,
      }
    default:
      return state
  }
}

const putTagError = (state = initialState.putTagError, { type, payload }) => {
  if (type === actions.PUT_CATEGORY_TAGS_FAILURE) {
    return payload
  }
  if (
    type === actions.PUT_CATEGORY_TAGS_REQUEST ||
    type === actions.PUT_CATEGORY_TAGS_SUCCESS
  ) {
    return null
  }

  return state
}

const putMarketError = (
  state = initialState.putMarketError,
  { type, payload },
) => {
  if (type === actions.PUT_MARKET_FAILURE) {
    return payload
  }
  if (
    type === actions.PUT_MARKET_REQUEST ||
    type === actions.PUT_MARKET_SUCCESS
  ) {
    return null
  }

  return state
}

export default combineReducers({
  isFetching,
  item,
  isPuttingTags,
  putTagError,
  isPuttingMarket,
  putMarketError,
  isPostingOpportunityTagsReviewed,
})



// WEBPACK FOOTER //
// ./src/reducers/opportunity.js